import React from 'react';
import classnames from 'classnames';
import Modal from 'scy/Modal';
import { MutedBackground, DarkBackground } from 'scy/Background';
import { H5, H2Alt } from 'scy/text';
import { sansSerifRegular, fontSizeS } from 'scy/text/styles.mod.scss';
import { TextButton } from 'scy/buttons';
import Logo from 'images/icons/logos/combo-drop-pin.svg?react-svg';
import AppleStoreIcon from 'images/apple-store-icon.png';
import GooglePlayIcon from 'images/google-play-icon.png';
import { textCenter, width100 } from 'scy/utils.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import border from 'scy/border.mod.scss';
import styles from './DownloadModal.mod.scss';

export default function DownloadModal({ isOpen, handleClose }) {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      hideCloseButton
      className={styles.modal}
    >
      <MutedBackground className={textCenter}>
        <DarkBackground tag="section" className={styles.background}>
          <div className={styles.logo}>
            <Logo />
          </div>
          <H5
            uppercase
            marginClass={classnames(margin.top_0, margin.bottom_sm)}
          >
            Delivery Confirmed!
          </H5>
          <H2Alt
            tag="p"
            className={styles.heading}
            marginClass={classnames(
              margin.top_0,
              margin.bottom_sm,
              margin.tablet_bottom_0
            )}
          >
            See you soon.
          </H2Alt>
        </DarkBackground>

        <section className={margin.bottom_md}>
          <div className={styles.appIcon}>
            <Logo />
          </div>
          <h5 className={styles.title}>What now?</h5>
          <p className={styles.paragraph}>Download the Saucey app.</p>
          <a
            href="https://app.adjust.com/o079l9_f06dhc"
            className={classnames(inlineBlock, margin.xs)}
          >
            <img
              width={100}
              src={AppleStoreIcon}
              className={styles.appStoreLink}
            />
          </a>
          <a
            href="https://app.adjust.com/f06dhc_o079l9"
            className={classnames(inlineBlock, margin.xs)}
          >
            <img
              width={100}
              src={GooglePlayIcon}
              className={styles.appStoreLink}
            />
          </a>
        </section>

        <div className={classnames(sansSerifRegular, fontSizeS)}>
          <TextButton
            noUnderline
            className={classnames(width100, padding.sm, border.topMedium)}
            onClick={handleClose}
          >
            Dismiss
          </TextButton>
        </div>
      </MutedBackground>
    </Modal>
  );
}
